import { createContext, useContext, useEffect, useMemo, useState, useRef } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";
import {
  trackEvent,
  setAmplitudeUser,
  clearAmplitudeUser,
} from "../services/amplitude";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 👉 запам'ятовуємо попереднього юзера
  const prevUserRef = useRef(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      setUser(u || null);
      setLoading(false);

      const prevUser = prevUserRef.current;

      // =========================
      // LOGIN
      // =========================
      if (u) {
        try {
          await u.getIdToken();

          setAmplitudeUser({
            uid: u.uid,
            email: u.email || null,
            displayName: u.displayName || null,
            emailVerified: !!u.emailVerified,
            providerId: u.providerData?.[0]?.providerId || null,
          });

          trackEvent("user_logged_in", {
            user_id: u.uid,
            provider_id: u.providerData?.[0]?.providerId || null,
            display_name: u.displayName || null,
            email_verified: !!u.emailVerified,
          });
        } catch (e) {
          console.error("Token error:", e);
        }
      }

      // =========================
      // LOGOUT
      // =========================
      if (!u && prevUser) {
        trackEvent("user_logged_out", {
          user_id: prevUser.uid,
          provider_id: prevUser.providerData?.[0]?.providerId || null,
        });

        clearAmplitudeUser();
        console.log("User logged out");
      }

      // 👉 оновлюємо попереднього юзера
      prevUserRef.current = u;
    });

    return () => unsub();
  }, []);

  const value = useMemo(() => ({ user, loading }), [user, loading]);

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
  return useContext(AuthCtx);
}